import { useState } from "react";
import { salesService } from "../services/sales.api";
import { useDispatch } from "react-redux";
import { setSales } from "store/salesSlice";
import { setSalesItems } from "store/salesSlice";
import { useSelector } from "react-redux";
import { selectSalesItems } from "store/salesSlice";

const useSales = () => {
  const dispatch = useDispatch();
  const salesList = useSelector(selectSalesItems);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getSalesList = async (data) => {
    setLoading(true);
    try {
      const response = await salesService.fetchList(data);
      if (response.success) {
        dispatch(setSalesItems(response));
      }
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
    }
  };

  const getSalesOptionList = async () => {
    setLoading(true);
    try {
      const response = await salesService.fetchOptionList();
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
    }
  };

  const createSales = async (payload) => {
    setLoading(true);
    try {
      const response = await salesService.createSalesRep(payload);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
    }
  };

  const updateSales = async (id, payload) => {
    setLoading(true);
    try {
      const response = await salesService.updateSalesRep(id, payload);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
    }
  };

  const deleteSales = async (id) => {
    setLoading(true);
    try {
      const response = await salesService.deleteSalesRep(id);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
    }
  };

  const getSalesById = async (id) => {
    setLoading(true);
    try {
      const response = await salesService.fetchSalesRepById(id);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
    }
  };

  const resendInvitation = async (id) => {
    setLoading(true);
    try {
      const response = await salesService.resendInvitation(id);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const assignDealers = async (id, payload) => {
    setLoading(true);
    try {
      const response = await salesService.assignDealers(id, payload);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const setTarget = async (id, payload) => {
    setLoading(true);
    try {
      const response = await salesService.setTarget(id, payload);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const getTargetBySalesId = async (id, payload) => {
    setLoading(true);
    try {
      const response = await salesService.getTargetBySalesId(id, payload);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  return {
    setTarget,
    getSalesList,
    getTargetBySalesId,
    salesList,
    createSales,
    getSalesById,
    getSalesOptionList,
    deleteSales,
    updateSales,
    loading,
    resendInvitation,
    assignDealers,
    error,
  };
};

export default useSales;
